import { Button, Group } from "@mantine/core"
import styles from "./ToggleButtonGroup.module.css"
import {
	AEM_DICTIONARY_COLLECTIONS,
	useAEMDictionary
} from "@AEM/hooks/useAEMDictionary"

interface ToggleButtonGroupProps {
	value: boolean
	onChange: (value: boolean) => void
	ariaLabel?: string
}

export const ToggleButtonGroup = ({
	value,
	onChange,
	ariaLabel
}: ToggleButtonGroupProps) => {
	const { dictionary } = useAEMDictionary(
		AEM_DICTIONARY_COLLECTIONS.REGISTRATION
	)

	const handleYesClick = () => {
		onChange(true)
	}

	const handleNoClick = () => {
		onChange(false)
	}

	const announceYes = () => {
		const liveRegion = document.getElementById("toggle-announcements")
		if (liveRegion) {
			liveRegion.textContent = `${dictionary?.yesTitle} ${value ? "selected" : "not selected"}`
		}
	}

	const announceNo = () => {
		const liveRegion = document.getElementById("toggle-announcements")
		if (liveRegion) {
			liveRegion.textContent = `${dictionary?.noTitle} ${!value ? "selected" : "not selected"}`
		}
	}

	return (
		<Group gap="xs" role="radiogroup" aria-label={ariaLabel}>
			<Button
				size="sm"
				onClick={handleYesClick}
				className={value ? styles.buttonActive : styles.button}
				aria-pressed={value}
				aria-label={`${dictionary?.yesTitle}`}
				onMouseEnter={announceYes}
				onFocus={announceYes}
			>
				{dictionary?.yesTitle}
			</Button>
			<Button
				size="sm"
				onClick={handleNoClick}
				className={!value ? styles.buttonActive : styles.button}
				aria-pressed={!value}
				aria-label={`${dictionary?.noTitle}`}
				onMouseEnter={announceNo}
				onFocus={announceNo}
			>
				{dictionary?.noTitle}
			</Button>
			<div
				id="toggle-announcements"
				aria-live="polite"
				style={{
					position: "absolute",
					left: "-10000px",
					width: "1px",
					height: "1px",
					overflow: "hidden"
				}}
			/>
		</Group>
	)
}
